import type { Food } from '@/hooks/useComprehensiveNutrition';
import type { SavedMealItem } from '@/hooks/useSavedMeals';

/** Build a Food object for logFoodToMeal from a saved meal item (avoids bogus food_id FK errors). */
export function savedMealItemToFood(item: Pick<
  SavedMealItem,
  'id' | 'food_id' | 'user_food_id' | 'food_name' | 'quantity' | 'unit' |
  'calories' | 'protein' | 'carbs' | 'fat' | 'fiber' | 'sugar' | 'sodium'
>): Food & { user_id?: string } {
  const linkedId = item.user_food_id || item.food_id;
  return {
    id: linkedId || `saved_item_${item.id}`,
    name: item.food_name,
    serving_size: item.quantity,
    serving_unit: item.unit,
    calories_per_serving: item.calories,
    protein_per_serving: item.protein,
    carbs_per_serving: item.carbs,
    fat_per_serving: item.fat,
    fiber_per_serving: item.fiber || 0,
    sugar_per_serving: item.sugar || 0,
    sodium_per_serving: item.sodium || 0,
    verified: false,
    ...(item.user_food_id ? { user_id: item.user_food_id } : {}),
  };
}

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function sanitizeFoodReferenceIds(
  foodId?: string | null,
  userFoodId?: string | null
): { food_id: string | null; user_food_id: string | null } {
  return {
    food_id: foodId && UUID_RE.test(foodId) ? foodId : null,
    user_food_id: userFoodId && UUID_RE.test(userFoodId) ? userFoodId : null,
  };
}
